import { render, staticRenderFns } from "./DocumentOptionList.vue?vue&type=template&id=18570963&scoped=true"
import script from "./DocumentOptionList.vue?vue&type=script&lang=js"
export * from "./DocumentOptionList.vue?vue&type=script&lang=js"
import style0 from "./DocumentOptionList.vue?vue&type=style&index=0&id=18570963&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18570963",
  null
  
)

export default component.exports